module.exports = __webpack_public_path__ + "img/icon_keyboard_del.5fac79ed.png";